import config from '@/config'
import lang from '@/lang'

import { customerTypes } from '@/modules/base/util/constants'
const { COMPANY, PERSON } = customerTypes

const urls = {
  single: 'customer',
  multiple: 'customers',
}

export const CUSTOMER_NUMBER_MIN = 10000
export const CUSTOMER_NUMBER_MAX = 69999

export default {
  resourceUrl: `${config.resourceHost}${urls.single}`,
  salesVolumeUrl: 'contact/getsalesvolumefromcontact',
  cityByZipUrl: `${config.serviceHost}cityzipcode/getcitiesfromzipcode`,
  findCity: `${config.resourceHost}find/city/`,
  nextCustomerNumber: `${config.resourceHost}customer/number`,
  fetchDefaultCustomerModelUrl: `${config.resourceHost}customer/new`,
  customerListSetting: `${config.resourceHost}setting/userlist/customer`,

  // active customer count
  getActiveCustomerUrl: `${config.resourceHost}customer/count/active`,

  // address url
  addressUrl: `${config.resourceHost}address`,

  customerHistoryUrl: `${config.serviceHost}contact/getprocessesfromcontact`,
  customerHistoryQuickfilters: [
    { name: 'all', label: lang.generics.allProperCase },
    { name: 'offer', label: lang.generics.offers },
    { name: 'order', label: lang.generics.orders },
    { name: 'deliveryNote', label: lang.generics.deliveryNotes },
    { name: 'invoice', label: lang.generics.invoices },
    { name: 'cancellation', label: lang.generics.cancellations },
    { name: 'creditNote', label: lang.generics.creditNotes },
    { name: 'letter', label: lang.generics.letters },
  ],
  clientUrl: urls,

  routes: {
    details: `${config.resourceHost}${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },

  options: {
    list: {
      name: urls.single,
      quickfilters: {
        models: [
          { name: 'all', title: 'Alle' },
        ],
      },
      defaultSort: { property: 'name', desc: false },
    },
  },
  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
    {
      name: PERSON,
      title: lang.customerList.privateCustomers,
      quickFilter: {
        kind: {
          type: 'set',
          values: [PERSON],
        },
      },
    },
    {
      name: COMPANY,
      title: lang.customerList.businessCustomers,
      quickFilter: {
        kind: {
          type: 'set',
          values: [COMPANY],
        },
      },
    },
  ],
}
